import ATE from './ActionTypeEnum';
import { mainInitialState } from './initial-state';
import IMainState from './IMainState';
import IDT from './pages/InputPage/interfaces/InputDataType';

export default function reduce(
    state: IMainState = mainInitialState,
    action: { type: ATE; value?: any }
): IMainState {
    switch (action.type) {
        case ATE.SET_MAIN_STATE: {
            const updater: Partial<IMainState> = action.value;
            return {
                ...state,
                ...updater,
            };
        }

        case ATE.RESET_MAIN_STATE:
            return mainInitialState;

        case ATE.CLICK_FIND_JOB_BTN:
            // TODO
            return state;

        case ATE.CHANGE_JOB_TITLE_FIELD:
            return {
                ...state,
                jobTitle: action.value,
            };

        case ATE.SET_JOB_ID:
        return {
            ...state,
            jobId: action.value,
        };

        case ATE.SET_WAITING_PDB:
        return {
            ...state,
            showWaitingPDB: action.value,
        };

        case ATE.SET_WAITING_CAT:
            return {
                ...state,
                showWaitingCat: action.value,
        };

        case ATE.SET_SEQUENCE_CHECKED:
            return{
                ...state,
                sequenceChecked: action.value,
            };

        case ATE.CHANGE_EMAIL_FIELD:
            return {
                ...state,
                email: action.value,
            };
        
        case ATE.LOAD_INDEXES:
            return{
                ...state,
                indexes: action.value,
            };

        case ATE.CHANGE_TYPE_INPUT_DATA:
            return {
                ...state,
                inputDataType: action.value,
                bFactorAnalysis: !(action.value === IDT.Sequence),
            };
        case ATE.TOGGLE_FORCE_FIELD_MUTATIONS:
            return {
                ...state,
                forceFieldMutations: !state.forceFieldMutations,
            };
        case ATE.TOGGLE_B_FACTOR_ANALYSIS:
            return {
                ...state,
                bFactorAnalysis: state.inputDataType === IDT.Sequence
                    ? state.bFactorAnalysis == false
                    : 
                    !state.bFactorAnalysis,
            };
        case ATE.TOGGLE_CONSENSUS_MUTATIONS:
            return {
                ...state,
                consensusMutations: !state.consensusMutations,
            };

        case ATE.GROUP_AUTOMATED_SINGLE_POINT:
            var new_state= !(state.forceFieldMutations && state.bFactorAnalysis && state.consensusMutations)
            return{
                ...state,
                forceFieldMutations: state.inputDataType === IDT.Sequence? 
                !(state.forceFieldMutations && state.consensusMutations): 
                !(state.forceFieldMutations && state.bFactorAnalysis && state.consensusMutations),

                bFactorAnalysis: state.inputDataType === IDT.Sequence? 
                    false: 
                    !state.bFactorAnalysis,

                consensusMutations: state.inputDataType === IDT.Sequence? 
                !(state.forceFieldMutations && state.consensusMutations): 
                !(state.forceFieldMutations && state.bFactorAnalysis && state.consensusMutations)
                
            }

        case ATE.GROUP_AUTOMATED_MULTIPLE_POINT:
            var new_state=!(state.lowRiskDesign && state.highRiskDesign && state.ancestralDesign)
            return{
                ...state,
                lowRiskDesign: new_state,
                highRiskDesign:new_state,
                ancestralDesign:new_state,
            }

        case ATE.CHANGE_CALCULATION:
            return {
                ...state,
                calculation: action.value,
            };

        case ATE.TOGGLE_MODELLING:
            return {
                ...state,
                modelling: !state.modelling,
            };

        case ATE.CHANGE_LOW_RISK_DESIGN:
            return {
                ...state,
                lowRiskDesign: !state.lowRiskDesign,
            };

        case ATE.CHANGE_HIGH_RISK_DESIGN:
            return {
                ...state,
                highRiskDesign: !state.highRiskDesign,
            };

        case ATE.CHANGE_ANCESTRAL_RISK_DESIGN:
            return {
                ...state,
                ancestralDesign: !state.ancestralDesign,
            };

        /*case ATE.CHANGE_MM_SELECTION:
            return{
                ...state,
                selectedMM: action.value,
            };*/

        case ATE.CHANGE_MAX_NUM_SEQ_FIELD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                    maxNumSeqField: action.value,
                },
            };

        case ATE.CHANGE_BLAST_E_VAL_FIELD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                blastEvalField: action.value,}
            };
        case ATE.CHANGE_MIN_IDENTITY_FIELD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                minIdentityField: action.value,}
            };

        case ATE.CHANGE_MAX_IDENTITY_FIELD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                maxIdentityField: action.value,
            }};

        // advanced options: identification of consensus residues 
        case ATE.CHANGE_MAJORITY_CONSENSUS_MIN_IDENTITY:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                majorityConsensusMinIdentity: action.value,
            }};
        case ATE.CHANGE_RATIO_CONSENSUS_MIN_FREQ:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                ratioConsensusMinFreq: action.value,
        }};
        case ATE.CHANGE_RATIO_CONSENSUS_MIN_RATIO:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                ratioConsensusMinRatio: action.value,
        }};
        case ATE.CHANGE_GLOBAL_CONSENSUS_GAP_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                globalConsensusGapThreshold: action.value,
        }};
        // END advanced options: identification of consensus residues

        // advanced options: threshold settings
        case ATE.CHANGE_EVOLUTION_FOLD_X_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                evolutionFoldXThreshold: action.value,
            }};
        case ATE.CHANGE_ENERGY_FOLD_X_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                energyFoldXThreshold: action.value,
        }};
        case ATE.CHANGE_LIMIT_FORCE_FIELD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                    limitForceFields: action.value,
            }};
        case ATE.CHANGE_ENERGY_ROSETTA_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                energyRosettaThreshold: action.value,
        }};
        case ATE.CHANGE_MULTIPOINT_ROSETTA_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                multipointRosettaThreshold: action.value,
        }};
        // END advanced options: threshold settings


        // advanced settings : analysis of correlated positions
        case ATE.CHANGE_Z_SCORE_THRESHOLD:
            return {
                ...state,
                advancedOptions: {
                    ...state.advancedOptions,
                zScoreThreshold: action.value,
                }
        };

        // END advanced settings : analysis of correlated positions

        case ATE.CHANGE_PDB_ID_FIELD:
            return {
                ...state,
                pdbIdField: action.value,
            };

        case ATE.CHANGE_UNIPROT_ID_FIELD:
            return {
                ...state,
                uniprotIdField: action.value,
            };

        case ATE.CHANGE_PDB_CHAIN_FIELD:
            return {
                ...state,
                pdbChainField: action.value,
            };

        case ATE.CHANGE_SEQUENCE_FIELD:
            return {
                ...state,
                sequence: action.value,
            };
        
        case ATE.SET_JOB_FINISHED:
            return {
                ...state,
                resultsLoaded: action.value,
            };
        
        case ATE.SET_SHOW_CHAINS_SELECTION:
            return {
                ...state,
                showChainsSelection: action.value
            };
        
        case ATE.SET_CALCULATION_TYPES:
            return {
                ...state,
                types: action.value,
            };

        case ATE.OBTAIN_CHAINS:
            return {
                ...state,
                chains: action.value,
            };

        case ATE.CHANGE_STRUCTURE_INFO:
            console.log("aaaaa")
            console.log(action)
            return{
                ...state,
                processedStructure: action.value,
            };
        case ATE.SET_SELECTED_STRUCTURE_INFO:
            return {
                ...state,
                selectedStructureInfo: action.value,
            };

        case ATE.SET_SITES_ANNOTATIONS:
            return {
                ...state,
                sitesAnotations: action.value,
            };

        case ATE.UPDATE_SITES_ANNOTATIONS:
            return {
                ...state,
                sitesAnotations: state.sitesAnotations.concat(action.value),
            };

        case ATE.SET_SELECTED_SITE_ANOTATIONS:
            return {
                ...state,
                selectedSiteAnotations: action.value,
            };
        case ATE.BTC_MUTATION_SUCCESS:
            return {
                ...state,
                BTCmutations: action.value,
            };
        case ATE.LOW_RISK_MUTATION_SUCCESS:
            return {
                ...state,
                LowRiskMutations: action.value,
            };
        case ATE.HIGH_RISK_MUTATION_SUCCESS:
            return {
                ...state,
                HighRiskMutations: action.value,
            };
        case ATE.COMBINED_LOW_RISK_MUTATION_SUCCESS:
            return {
                ...state,
                CombinedLowRiskMutations: action.value,
            };
        case ATE.COMBINED_HIGH_RISK_MUTATION_SUCCESS:
            return {
                ...state,
                CombinedHighRiskMutations: action.value,
            };
        case ATE.ANCESTRAL_DESIGNS_SUCCESS:
            return {
                ...state,
                ancestralDesigns: action.value,
            };
        /*case ATE.OBTAIN_PROTEIN_SEQUENCE:
            return{
                ...state,
                sequence: action.value,
            }*/
        case ATE.ALL_RESIDUES_MUTATION_SUCCESS:
            return {
                ...state,
                allResidues: action.value,
            };
        //adds mutation if is not in the array or remoes mutation of it is in the array
        case ATE.ADD_REMOVE_MUTATION:
            return {
                ...state,
                sPMutations: state.sPMutations.some(
                    (mutation) =>
                        mutation.position === action.value.position &&
                        mutation.base === action.value.base
                )
                    ? state.sPMutations.filter(
                            (mutation) =>
                                mutation.position !== action.value.position ||
                                mutation.base !== action.value.base
                      )
                    : [...state.sPMutations, action.value],
            };

        case ATE.REMOVE_MUTATIONS_ON_POSITION:
            return {
                ...state,
                sPMutations: state.sPMutations.filter(
                            (mutation) =>
                                mutation.position !== action.value.position
                      )
        };

        

        case ATE.ADD_ALL_MUTATIONS_ON_POSITION: {
            const bases = [
                'A',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'K',
                'L',
                'M',
                'N',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'V',
                'W',
                'Y',
            ].filter((b) => b != action.value.base);
            console.log('bases', bases);
            console.log('base', action.value.base);
            const position = action.value.position;

            // already selected target bases
            const selectedBases: string[] = state.sPMutations
                .filter((m) => m.position === position)
                .map((m) => m.base);

            // which target bases should be selected now
            const toSelectNow = bases.filter((b) => !selectedBases.includes(b));

            // create new mutations
            const newMutations = toSelectNow.map((b) => ({
                position: position,
                base: b,
            }));

            return {
                ...state,
                sPMutations: [...state.sPMutations, ...newMutations],
            };
        }

        case ATE.ADD_CUSTOM_MUTANT_MUTATIONS: 
            return     {
                    ...state,
                    CustomMutantMutations: [...state.CustomMutantMutations,action.value],
                    
                }

        case ATE.REMOVE_CUSTOM_MUTANT_MUTATIONS: 
            return     {
                    ...state,
                    CustomMutantMutations: state.CustomMutantMutations.filter(
                        (mutation) =>
                            mutation !== action.value
                  )
        }       
        
        case ATE.CLEAR_MUTATIONS:
            return {
                ...state,
                CustomMutantMutations: []
            }

        case ATE.SET_CALCULATION_MAPPING:
            return {
                ...state,
                chainMapping: action.value
            }
        
        case ATE.SET_RESULT_PDB:
            return {
                ...state,
                pdbIdField: action.value
            }
        
        case ATE.ADD_USER_RESIDUE:
            return {
                ...state,
                userSiteAnnotations: [action.value, ...state.userSiteAnnotations],
                sitesAnotations: [action.value, ...state.sitesAnotations],

            }
        
        default:
            return state;
    }
}
